// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
function TruncatedContainer(Props) {
  var children = Props.children;
  var match = ViewportContext$Showside.use(undefined);
  var windowHeight = match.windowSize.height;
  var match$1 = React.useState(function () {
    return false;
  });
  var setExpanded = match$1[1];
  var expanded = match$1[0];
  var ref = React.useRef(null);
  React.useEffect(function () {
    var el = ref.current;
    if (!(el == null)) {
      var scrollHeight = el.scrollHeight;
      var clientHeight = el.clientHeight;
      if ((scrollHeight - clientHeight | 0) === 0) {
        Curry._1(setExpanded, function (param) {
          return true;
        });
      }
    }
  }, []);
  var style = React.useMemo(function () {
    var maxHeight = expanded ? undefined : CSS$Showside.intToPx(windowHeight / 2 | 0);
    var tmp = {};
    if (maxHeight !== undefined) {
      tmp.maxHeight = maxHeight;
    }
    return tmp;
  }, [expanded, windowHeight]);
  var handleClick = function (e) {
    Curry._1(setExpanded, function (prev) {
      return !prev;
    });
  };
  var renderReadMoreButton = function (expanded) {
    if (expanded) {
      return null;
    } else {
      return React.createElement(DataAttribute$Showside.make, {
        dataTestId: "truncated-container-read-more",
        children: React.createElement("div", {
          className: CSS$Showside.prefix("cursor-pointer text-lg absolute bottom-0 left-0 w-full h-24 pb-3 text-center text-accent font-medium flex items-end justify-center"),
          style: {
            background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, var(--smartnav-background-color) 60%)"
          },
          tabIndex: 0,
          onClick: handleClick
        }, "Read More")
      });
    }
  };
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    className: CSS$Showside.prefix("relative overflow-hidden"),
    style: style
  }, children, renderReadMoreButton(expanded));
}
TruncatedContainer.displayName = "TruncatedContainer";
var make = TruncatedContainer;
export { make };
/* react Not a pure module */